import { SimpleGrid, Stack, Text } from '@mantine/core';
import type { AdminProgramme } from '@/api/types';
import { ImageSlot } from '@/components/ImageSlot';
import { ARTWORK_SLOTS } from '@/lib/image';
import { Section } from './DetailsTab';
import { useProgrammeFormContext } from './formContext';

export function ArtworkTab({ programme }: { programme: AdminProgramme }) {
  const form = useProgrammeFormContext();
  const art = form.getValues().artwork;
  return (
    <Section
      title="Artwork"
      description="Poster, landscape and thumbnail are required to approve. Images upload straight away; save the programme to use them."
    >
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        {ARTWORK_SLOTS.map((s) => (
          <ImageSlot
            key={s.slot}
            kind={s.slot}
            label={s.label}
            hint={s.hint}
            ratio={s.ratio}
            previewWidth={s.slot === 'poster' ? 180 : 320}
            value={art[s.slot]}
            onChange={(v) => form.setFieldValue(`artwork.${s.slot}`, v)}
          />
        ))}
      </SimpleGrid>
      <Stack gap={2}>
        <Text size="xs" c="dimmed">
          JPEG, PNG or WebP up to 10 MB. Children see artwork inside an ink outline; keep important
          detail away from the edges.
        </Text>
        {programme.status === 'published' && (
          <Text size="xs" c="orange.8">
            Saving new artwork changes the live programme straight away.
          </Text>
        )}
      </Stack>
    </Section>
  );
}
